<template>
    <v-row
        class="actions-row"
        :justify="compactLayout ? 'end' : 'space-between'"
        align="center"
        :no-gutters="compactLayout"
        :class="{ 'actions-row--padded': !compactLayout }"
    >
        <!-- Refresh -->
        <v-col v-if="!disableRefreshButton" cols="auto" class="action-col">
            <div class="text-center">
                <v-btn
                    class=""
                    elevation="0"
                    fab
                    light
                    small
                    @click="onRefresh"
                    :color="theme.footerIconColor"
                >
                    <v-icon dark :color="theme.headerFooterColor"> mdi-cached </v-icon>
                </v-btn>
                <!--<div class="caption">{{modeTitle}}</div>-->
            </div>
        </v-col>

        <!-- Switch Mode -->
        <v-col v-if="!disableTilesButton" cols="auto" class="action-col">
            <div class="text-center">
                <v-btn
                    class=""
                    elevation="0"
                    fab
                    light
                    small
                    @click="onSwitchMode"
                    :color="theme.footerIconColor"
                >
                    <v-icon dark :color="theme.headerFooterColor">
                        {{ modeIcon }}
                    </v-icon>
                </v-btn>
                <!--<div class="caption">{{modeTitle}}</div>-->
            </div>
        </v-col>

        <!-- Switch Order -->
        <v-col v-if="!disableSortButton" cols="auto" class="action-col">
            <div class="text-center">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class=""
                            elevation="0"
                            fab
                            light
                            small
                            :color="theme.footerIconColor"
                        >
                            <v-icon dark :color="theme.headerFooterColor">
                                {{ sortIcon }}
                            </v-icon>
                        </v-btn>
                    </template>
                    <v-list :style="{'background-color':theme.headerFooterColor}">
                        <v-list-item
                            v-for="(value, name) in sortListOptions"
                            :key="name"
                            link
                            @click="onChangeOrder(name)"
                            :style="{'color':theme.footerIconColor + '!important'}"
                        >
                            <v-list-item-icon
                            ><v-icon :color="theme.footerIconColor">{{
                                    value.icon[value.sortOrder]
                                }}</v-icon></v-list-item-icon
                            >
                            <v-list-item-content>
                                <v-list-item-title>{{
                                        value.label
                                    }}</v-list-item-title></v-list-item-content
                            >
                        </v-list-item>
                    </v-list>
                </v-menu>

                <!--<div class="caption">{{$t('task_list_sort_order')}}</div>-->
            </div>
        </v-col>

    </v-row>
</template>

<script>
import CONFIG from "../../constants/config";
import {layoutMixin} from "../../utils/layout-mixin";

export default {
    mixins: [layoutMixin],
    components: {},
    props: {
        mode: {
            type: Number,
            default: 0,
        },
        compactLayout: {
            type: Boolean,
            default: false,
        },
        sortOrder: {
            type: String,
            default: 'asc',
        },
        sortOption: {
            type: String,
            default: 'byNumber',
        },
    },
    data: function () {
        return {
            switchListMode: 0,
            sortListOrder: 'asc',
            sortListOption: 'byNumber',
        };
    },
    watch: {
        /* Init data on creation and on update */
        mode: {
            handler(val) {
                this.switchListMode = val;
            },
            immediate: true,
        },
        sortOrder: {
            handler(val) {
                this.sortListOrder = val;
            },
            immediate: true,
        },
        sortOption: {
            handler(val) {
                this.sortListOption = val;
            },
            immediate: true,
        },
    },
    computed: {
        disableRefreshButton() {
            return this.parseBoolean(CONFIG.DISABLE_TASK_REFRESH_BTN, false)
        },
        disableTilesButton() {
            return this.parseBoolean(CONFIG.DISABLE_TASK_TILE_BTN, false)
        },
        disableSortButton() {
            return this.parseBoolean(CONFIG.DISABLE_TASK_SORT_BTN, false)
        },
        isListMode() {
            return this.switchListMode == CONFIG.SPOT_LIST_MODE_LIST;
        },
        isSortModeASC() {
            return this.sortListOrder == 'asc';
        },
        modeTitle() {
            return this.isListMode
                ? this.$t('taskListNormal')
                : this.$t('taskListTiles');
        },
        modeIcon() {
            return this.isListMode ? 'mdi-view-list' : 'mdi-view-agenda';
        },
        sortIcon() {
            return this.sortListOptions[this.sortListOption].icon[this.sortListOrder];
        },

        sortListOptions() {
            return {
                byNumber: {
                    icon: {
                        asc: 'mdi-sort-numeric-ascending',
                        desc: 'mdi-sort-numeric-descending',
                    },
                    label: this.$t('sortByNumber'),
                    sortOrder: 'asc',
                },
                byName: {
                    icon: {
                        asc: 'mdi-sort-alphabetical-ascending',
                        desc: 'mdi-sort-alphabetical-descending',
                    },
                    label: this.$t('sortByName'),
                    sortOrder: 'asc',
                },
                byPoints: {
                    icon: {
                        asc: 'mdi-sort-bool-ascending',
                        desc: 'mdi-sort-bool-descending',
                    },
                    label: this.$t('taskPoints'),
                    sortOrder: 'asc',
                },
            }
        },
    },
    methods: {
        onSwitchMode() {
            this.switchListMode = this.isListMode
                ? CONFIG.SPOT_LIST_MODE_TILE
                : CONFIG.SPOT_LIST_MODE_LIST;
            this.$emit('switchListMode', this.switchListMode);
        },

        onChangeOrder(optionName) {
            if (this.sortListOption === optionName) {
                //when sort option already selected, change sort order
                if (this.sortListOptions[optionName].sortOrder === 'asc') {
                    this.sortListOptions[optionName].sortOrder = 'desc';
                    this.sortListOrder = 'desc';
                } else {
                    this.sortListOptions[optionName].sortOrder = 'asc';
                    this.sortListOrder = 'asc';
                }
            } else {
                //set the new sort option and corresponding sort order
                this.sortListOption = optionName;
                this.sortListOrder = this.sortListOptions[optionName].sortOrder;
            }
            this.$emit('changeSortOrder', {
                order: this.sortListOrder,
                option: this.sortListOption,
            });
        },

        onRefresh() {
            this.$emit('refresh');
        },
    },
};
</script>

<style scoped>
.actions-row {
    flex-wrap: wrap;
    gap: 4px;
    max-width: 100%;
    margin: 0;
}
.actions-row--padded {
    padding-left: 8px;
    padding-right: 8px;
}
.action-col {
    flex: 0 0 auto;
    padding: 0 !important;
}
</style>